export default __webpack_public_path__ + "static/media/otherformat.b2964e50.svg";